import API from '../../../../services/api-middleware';
import { tableFunctionsProps } from '../../gateway/gateway.props';
import { EmbeddedLlmDetailsProps, embeddedProviderDetailsProps } from '../embedded.props';

const baseUrl = process.env.REACT_APP_LLM_SERVER_URL;

export const createEmbeddedProvider = async (payload: embeddedProviderDetailsProps) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`embedding/provider`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getEmbeddedModels = async (payload: tableFunctionsProps) => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(
      `embedding/model?limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&sort_col=${payload.sort_col}&sort_order=${payload.sort_order}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getEmbeddedProviders = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`embedding/provider?all=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createEmbeddedModel = async (payload: EmbeddedLlmDetailsProps) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`embedding/model`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const editEmbeddedModel = async (payload: EmbeddedLlmDetailsProps) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).put(`embedding/model`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteEmbeddedModel = async (id: Array<number>) => {
  const data = {
    ids: id,
  };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).delete(`embedding/model`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
